/**
 * Custom Content: all UI strings for the custom content mixin,
 * covering custom fields and panels save/remove dialogs.
 */

export const customContentEn = {
  customContent: {
    mixin: {
      savedToast: 'Custom content saved!',
      removeCustomFieldTitle: 'Remove Custom Field',
      removeCustomFieldText: 'Are you sure you want to remove custom field "{label}"?',
      removeCustomFieldConfirm: 'Remove',
      removedFieldToast: 'Custom field removed!',
      removePanelTitle: 'Confirm Removal',
      removePanelText: 'Are you sure you want to remove content "{name}"?',
      removePanelConfirm: 'Remove',
      removedPanelToast: 'Content removed!',
    },
  },
} as const;

export const customContentFr = {
  customContent: {
    mixin: {
      savedToast: 'Contenu personnalisé enregistré !',
      removeCustomFieldTitle: 'Supprimer le champ personnalisé',
      removeCustomFieldText: 'Êtes-vous sûr de vouloir supprimer le champ personnalisé « {label} » ?',
      removeCustomFieldConfirm: 'Supprimer',
      removedFieldToast: 'Champ personnalisé supprimé !',
      removePanelTitle: 'Confirmer la suppression',
      removePanelText: 'Êtes-vous sûr de vouloir supprimer le contenu « {name} » ?',
      removePanelConfirm: 'Supprimer',
      removedPanelToast: 'Contenu supprimé !',
    },
  },
} as const;
